import Grid from '@mui/material/Grid';
import { Field } from 'formik';
import { PaymentMethod } from '../../../store/config/types';
import { FormTextField } from '../FormTextField';

interface SoftDescriptorProps {
  paymentMethod?: PaymentMethod | null;
}

function SoftDescriptor({ paymentMethod }: SoftDescriptorProps) {
  return (
    <Grid container spacing={0}>
      <Grid size={12}>
        <Field
          name="softDescriptor"
          component={FormTextField}
          type="text"
          placeholder="Soft descriptor"
          disabled={!!paymentMethod}
        />
      </Grid>
      <Grid size={12} className="soft-descriptor">
        El "Soft Descriptor" es el texto que verá el cliente en el estado de cuenta de su tarjeta o banco.
      </Grid>
    </Grid>
  );
}

export default SoftDescriptor;
